export default __webpack_public_path__ + "static/media/trash-colorized.25803194.svg";